module.exports = __webpack_public_path__ + "static/media/drag_reorder_mobile.b60bea33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/drag_reorder_mobile.jpg
// module id = 263
// module chunks = 0